import { useLocation, Path } from 'components/_hooks/use-router';
import { useZoomWs } from 'components/app/_mediator/zoom/use-zoom-effects';
import { useRangeMarkersFc } from 'components/app/_mediator/range-markers/use-range-markers-fc';
import { useRangeMarkersSb } from 'components/app/_mediator/range-markers/use-range-markers-sb';
import { useMarkers } from 'components/app/editor/_mediator/editor-markers/use-markers';
import { useEditor } from 'components/app/editor/_mediator/use-editor';
import { usePanZoomStore } from 'components/app/editor/pan-zoom/_mediator/use-pan-zoom-store';
import { useSbWs } from 'components/app/storyboard/_mediator/use-sb-ws';
import { useFinalcutWs } from 'components/app/finalcuts/_mediator/use-finalcut-ws';
import { useWsListeners } from './lib/use-ws-listeners';
import { useWsPlayback } from './lib/use-ws-playback';
import { useWsCells } from './lib/use-ws-cells';
import { useWs } from './lib/use-ws';

interface Props {
  ws: WaveSurfer;
}

interface AudioProps {
  root: HTMLDivElement;
  ws: WaveSurfer;
}

const EditorHooks = ({ ws }: Props) => {
  usePanZoomStore();
  useMarkers(ws);
  useEditor();
  return null;
};

const StoryboardHooks = ({ ws }: Props) => {
  useSbWs(ws);
  useRangeMarkersSb(ws);
  return null;
};

const FinalcutHooks = ({ ws }: Props) => {
  useFinalcutWs(ws);
  useRangeMarkersFc(ws);
  return null;
};

export const AudioTrackHooks = ({ ws, root }: AudioProps) => {
  const { path } = useLocation();
  useZoomWs(root);
  useWsListeners(ws);
  useWsPlayback(ws);
  useWsCells();
  useWs();

  return (
    <>
      {(path === Path.selector || path === Path.storyboard) && <EditorHooks ws={ws} />}
      {path === Path.storyboard && <StoryboardHooks ws={ws} />}
      {path === Path.finalcuts && <FinalcutHooks ws={ws} />}
    </>
  );
};
